import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'

import { WEBSITE_BACKEND_PROXY_GRAPHQL } from '@definitions/config/websiteBackendProxyRoutes'

/**
 * Browser Apollo Client — all requests go through the Backend proxy.
 * Server-side data fetching uses @server/symfony/apollo-query instead.
 */
const httpLink = new HttpLink({
  uri: WEBSITE_BACKEND_PROXY_GRAPHQL,
  credentials: 'same-origin',
})

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
})

export default client
